import * as ko from "knockout";
import template from './CookieConsent.html';
import { setCookie } from 'typescript-cookie';
import { isAllowedUrl } from '../configuration';

class CookieConsent {

  consentMessageTitle: ko.Observable<string> = ko.observable<string>("");
  consentMessage: ko.Observable<string> = ko.observable<string>("");
  consentDetailsLinkUri: ko.Observable<string> = ko.observable<string>("");
  consentDetailsLinkText: ko.Observable<string> = ko.observable<string>("");
  acceptButton: ko.Observable<string> = ko.observable<string>("");
  rejectButton: ko.Observable<string> = ko.observable<string>("");
  rejectLinkUri: ko.Observable<string> = ko.observable<string>("");

  // Computed properties - initialized in constructor
  selectedLanguage: ko.PureComputed<string>;

  constructor() {
    global.Logonme.log("CookieConsent:constructor");

    // Initialize computed properties
    this.selectedLanguage = ko.pureComputed<string>(() => global.Logonme.SelectedLanguage());

    this.updateStrings(this.selectedLanguage());
    this.selectedLanguage.subscribe((lang: string) => {
      this.updateStrings(lang);
    });
  }

  async doAccept(): Promise<void> {
    global.Logonme.log("doAccept");
    const tenant = global.Logonme.Configuration.tenant;
    setCookie(".logonme-cookie-consent", tenant, { path: '/', expires: 365 });
    global.Logonme.HasConsent(true);
  }

  async doReject(): Promise<void> {
    global.Logonme.log("doReject");
    const rejectUri = this.rejectLinkUri();
    const allowedTargets = global.Logonme.FrontendConfig.allowedRedirectTargets;
    if (!isAllowedUrl(rejectUri, allowedTargets)) {
      const msg = `Redirect blocked: '${rejectUri}' is not in the allowed redirect targets. Update 'Allowed Redirect Targets' in Authentication Service Settings.`;
      console.error(msg);
      alert(msg);
      return;
    }
    window.location.href = rejectUri;
  }

  private updateStrings(lang: string): void {
    this.consentMessageTitle(global.Logonme.LocalizationManager.getText('cookie-consent-title', lang));
    this.consentMessage(global.Logonme.LocalizationManager.getText("cookie-consent-text", lang));
    this.consentDetailsLinkUri(global.Logonme.LocalizationManager.getText("cookie-consent-details-link-uri", lang));
    this.consentDetailsLinkText(global.Logonme.LocalizationManager.getText("cookie-consent-details-link-text", lang));
    this.rejectLinkUri(global.Logonme.LocalizationManager.getText("cookie-consent-reject-link-uri", lang));
    this.acceptButton(global.Logonme.LocalizationManager.getText("cookie-consent-accept-button", lang));
    this.rejectButton(global.Logonme.LocalizationManager.getText("cookie-consent-reject-button", lang));
  }
}

export default { viewModel: CookieConsent, template: template };
